import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { GeneralSetting } from '../../../models/general-setting.model';
import { User } from '../../../models/user.model';
import { AdminService } from '../../../services/admin.service';
import { UserService } from '../../../services/user.service';
import {
  VacationPolicy,
  VacationPolicyUpdateRequest
} from '../../common/vacation/vacation.models';
import { AppConstants } from '../view-user-profile/app.constants';
import {
  VIEW_USER_REPORT_ROLE_NOT_FOUND_INDEX,
  VIEW_USER_REPORT_ROUTES
} from './view-user-report.option';

@Injectable()
export class ViewUserReportGateway {
  constructor(
    private userService: UserService,
    private router: Router,
    private adminService: AdminService
  ) {}

  enterForCurrentAdmin(): User {
    const user = this.userService.getLocal();
    if (!this.isAdmin(user)) {
      this.router.navigate([VIEW_USER_REPORT_ROUTES.DASHBOARD]);
      return null;
    }
    return user;
  }

  loadCurrentUser(userId: string): Observable<Object> {
    return this.userService.getUserFromAPI(userId);
  }

  loadGeneralSettings(): Observable<HttpResponse<GeneralSetting>> {
    return this.adminService.getGeneralSettings();
  }

  saveGeneralSettings(settings: GeneralSetting): Observable<HttpResponse<GeneralSetting>> {
    return this.adminService.saveGeneralSettings(settings);
  }

  loadVacationPolicy(): Observable<VacationPolicy> {
    return this.adminService.getVacationPolicy();
  }

  saveVacationPolicy(request: VacationPolicyUpdateRequest): Observable<VacationPolicy> {
    return this.adminService.updateVacationPolicy(request);
  }

  private isAdmin(user: User): boolean {
    return !!user
      && !!user.roles
      && user.roles.indexOf(AppConstants.ROLES.ADMIN)
        !== VIEW_USER_REPORT_ROLE_NOT_FOUND_INDEX;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/view-user-report.gateway.ts